var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFolder = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Documents---Move-file---2",
    transform: "translate(-394.000000, -165.000000)",
    fill: "#CBC2BC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(378.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8785997,19.4933792 L22.8173151,17.0790108 C22.774137,17.0271095 22.7094356,16.9980026 22.6419726,17 L16.9988026,17.0067573 C16.4469858,17.0074181 16,17.4549394 16,18.0067566 L16,30.2819259 C16,30.8342106 16.4477153,31.2819259 17,31.2819259 L31,31.2819259 C31.5522847,31.2819259 32,30.8342106 32,30.2819259 L32,20.4968422 C31.9994341,19.9447783 31.5520636,19.4971547 31.0000002,19.4962765 L25.8785997,19.4933792 L25.8785997,19.4933792 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folder.65a0e542.svg";
export { ForwardRef as ReactComponent };